import axios from "axios";
import {Message} from "element-ui";
import router from "../router/index";
import tenantIdHeader from "./tenantId-header";

let wxEnv = "release";
// eslint-disable-next-line no-unused-vars
export const getBaseUrl = () => {
    let productionDomain = "e-learning.life-develop.com";
    let testDomain = "test-e-learning.life-develop.com";
    let developDomain = "dev-e-learning.life-develop.com";
    let localDomain = "local-e-learning.life-develop.com";

    let currentUrl = window.location.hostname;

    if (currentUrl === productionDomain) {
        wxEnv = "release";
        return "https://api.life-develop.com";
    }
    if (currentUrl === testDomain) {
        wxEnv = "trial";
        return "http://test-api.life-develop.com";
    }
    if (currentUrl === developDomain) {
        wxEnv = "develop";
        return "http://dev-api.life-develop.com";
    }
    if (currentUrl === localDomain) {
        wxEnv = "trial";
        return "http://local-e-learning.life-develop.com/";
        // return "http://test-api.life-develop.com";
    }
    return "http://localhost:2048";
};
export {wxEnv}
export default function request(
    url,
    type = "GET",
    data = {},
    isFile = false,
    isUpload = false
) {
    return new Promise((resolve, reject) => {
        const tenantId = tenantIdHeader();
        let option = {
            // 开发时使用，上线时删除
            // url: `${url}/`,
            // 发布时使用，开发时删除
            url: `${getBaseUrl()}/${url}/`,
            method: type,
            headers: tenantId,
        };
        if (isFile) {
            option["responseType"] = "arraybuffer";
        }
        if (isUpload) {
            option["headers"]["Content-Type"] = "multipart/form-data";
        }
        if (type.toLowerCase() === "get") {
            option.params = data;
        } else {
            option.data = data;
        }
        axios(option)
            .then((res) => {
                // >>>>>>>>>>>>>> 请求成功 <<<<<<<<<<<<<<
                // 开发时使用，上线时删除
                console.log(
                    `%c【${option.method} ${option.url}】请求成功，响应数据：`,
                    "color:white;background:#10689c;border-radius:3px;" +
                    "padding:4px;font-family:Microsoft YaHei;font-size:1em;",
                    res.data
                );
                // 处理下载文件出错时的错误信息
                // 若 Response 的 Content-Type 为 application/json，则先将返回的数据转换成字符串，然后再转换为 JSON
                if (
                    isFile &&
                    res.headers["content-type"].indexOf("application/json") > -1
                ) {
                    const formatRes = JSON.parse(Buffer.from(res.data).toString("utf8"));
                    // 处理业务错误
                    if (formatRes.message && !formatRes.success) {
                        Message.error(formatRes.message);
                        reject(res);
                    }
                    resolve(formatRes);
                    return;
                }
                // 处理业务错误
                if (res.status === 200 && res.data.message && res.data.code !== 0) {
                    Message.error(res.data.message);
                    reject(res);
                }
                resolve(res.data);
            })
            .catch((err) => {
                // >>>>>>>>>>>>>> 请求失败 <<<<<<<<<<<<<<
                const status = err.response.status;
                const errorText = err.response.statusText;
                if (status === 400) {
                    if (err.response.data.message && !err.response.data.success) {
                        return Message.error(err.response.data.message);
                    }
                    if (err.response.data && typeof err.response.data === "string") {
                        Message.error(err.response.data);
                    } else if (
                        err.response.data &&
                        typeof err.response.data === "object"
                    ) {
                        // for (const key in err.response.data) {
                        //     const errMsgList = err.response.data[key]
                        //     errMsgList.map((item) => {
                        //         if (typeof item === 'string') {
                        //             console.log(item)
                        //             Message.error(item)
                        //         }
                        //     })
                        // }
                    }
                } else if (status === 401) {
                    localStorage.clear();
                    Message.error("登录已过期，请重新登录");
                    router.push({name: "Login"}, () => {
                    });
                } else if (status === 403) {
                    Message.error("您没有权限！");
                } else if (status === 500) {
                    Message.error("内部服务器错误！");
                } else {
                    Message.error(`请求错误 ${status}：${errorText}`);
                }
                // 开发时使用，上线时删除
                console.error(
                    `【${option.method} ${option.url}】请求失败，响应数据：`,
                    err.response
                );
                reject(err.response.data);
            });
    });
}
